import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Router, Routes} from '@angular/router';

@Component({
  selector: 'app-why-success',
  templateUrl: './create-account-success.component.html',
  styles: [`
    .modal-container {
      background: #FFF9F2;
    }
  `]
})

export class CreateAccountSuccessComponent {
  constructor(private modalController: ModalController,
              private route: Router) {
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
